import { render, staticRenderFns } from "./TruformeComplete.vue?vue&type=template&id=0258f944"
import script from "./TruformeComplete.vue?vue&type=script&lang=js"
export * from "./TruformeComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports